import { useState } from 'react';
import { AxiosError } from 'axios';
import { useQuery } from '@tanstack/react-query';
import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import Header from '../../../../customs/Header';
import apiCall from '../../../../utils/apiCall';
import ApplicationPeriodTable from './Table';
import CreateApplicationPeriod from './CreateApplicationPeriod';
import SettingsModal from '../Modal/settingsCustomModal';
import { ApplicationPeriod } from '../../ApplicantDetails/type';


interface ApplicationPeriodResponse {
  StatusCode: number;
  Message: string;
  Data: ApplicationPeriod[];
}

// interface ApplicationPeriod {
//   ApplicationPeriodId: number;
//   RouteId: number;
//   StateDate: string;
//   EndDate: string;
//   Status: boolean;
//   Year: number;
// }

export default function Main() {
  const [createApplicationPeriodModal, setCreateApplicationModal] = useState(false);

  const handleOpenCreateApplicationModal = () => setCreateApplicationModal(true);
  const handleCloseCreateApplicationModal = () => setCreateApplicationModal(false);

  const getAllApplicationPeriods = async (): Promise<ApplicationPeriodResponse> => {
    return (await apiCall().get('/SetUp/GetAllApplicationPeriod')).data;
  };

  const { data, isLoading, isError, error } = useQuery(['get-application-periods'], getAllApplicationPeriods, {
    retry: 0,
    keepPreviousData: true,
    enabled: true,
  });

  const getApplicationPeriodError = error as AxiosError;
  const getApplicationPeriodErrorMessage = getApplicationPeriodError?.message;

  return (
    <section>
      <Header props = {
        { 
          firstName: 'All', 
          secondName: 'Application Periods', 
          buttonText: 'Create Application Period', 
        }}
        handleOpen={handleOpenCreateApplicationModal}
      />

      {isLoading ? (
        <CircularProgress 
          sx={{
            fontSize: '1rem',
            marginInline: 'auto',
            display: 'block',
            marginBlock: '2rem',
          }}
        />
      ) : isError ? (
        <StyledError>{getApplicationPeriodErrorMessage}</StyledError>
      ) : (
        <StyledContainer>
       <ApplicationPeriodTable data={data} />
        </StyledContainer>
      )}
      
      <SettingsModal 
        open={createApplicationPeriodModal}
        cancel={handleCloseCreateApplicationModal}
        maxWidth='920px'
        header='Create Application Period'
        showrightIcon={false}
        content={<CreateApplicationPeriod handleClose={handleCloseCreateApplicationModal}/>}
      />
    </section>
  )
};

const StyledContainer = styled.div`
  margin-block: 61px;
  margin-inline: 48px;
`

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`
